import { useMutation, useQueryClient } from "@tanstack/react-query"

import { SHIPPING_SCHEDULE_QUERY_KEY } from "@/constants/query"
import { cancelShippingSchedule, markAsSelectTransport } from "@/http/shippingSchedule"

import { useMessage } from "@/hook/useMessage"

export const useShippingScheduleMutation = () => {
    const client = useQueryClient()
    const { Success, Error, Process } = useMessage(SHIPPING_SCHEDULE_QUERY_KEY)

    const onSuccess = () => {
        client.invalidateQueries([SHIPPING_SCHEDULE_QUERY_KEY]).then()
        Success()
    }

    const onMutate = () => {
        Process()
    }

    const onError = (e: any) => {
        Error(e)
    }

    const markAsSelectTransportMutation = useMutation({
        mutationFn: markAsSelectTransport,
        onSuccess: () => onSuccess(),
        onMutate: () => onMutate(),
        onError: (e) => onError(e)
    })

    const cancelShippingScheduleMutation = useMutation({
        mutationFn: cancelShippingSchedule,
        onSuccess: () => onSuccess(),
        onMutate: () => onMutate(),
        onError: (e) => onError(e)
    })

    return {
        markAsSelectTransportMutation,
        cancelShippingScheduleMutation
    }
}